import React, { useEffect } from "react";
import ConGenMain from "../../../../Components/ConsumerGenerator/ConGenMain";
import { useDispatch, useSelector } from "react-redux";
import { fetchSelfCapacity } from "../../../../Redux/Slices/CapacitySlice";

const Consumer_Generator_Dashboard = () => {
  const dispatch = useDispatch();
  const user = useSelector(
    (state) => state.persistedReducer.user?.activeRole
  )?.toLowerCase();
  const name = useSelector(
    (state) => state.persistedReducer.user?.user?.fullName
  );

  const userType = useSelector((state) => state?.persistedReducer.userType);

  useEffect(() => {
    if (user && userType !== "COMPANY_ADMIN" && name) {
      dispatch(fetchSelfCapacity({ user: user }));
    }
  }, [dispatch, user, userType, name]);

  return (
    <div style={{ height: "100%", width: "100%" }}>
      <ConGenMain />
    </div>
  );
};

export default Consumer_Generator_Dashboard;
